export default {
  seasonProducts: []
}
